import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "main-content bg_gray d-flex flex-column transition overflow-hidden",
  style: {"height":"100vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success mx-3 mt-2 mb-0 d-flex justify-content-between align-items-center fs-14 py-2"
}
const _hoisted_3 = { class: "pos-layout flex-grow-1 overflow-hidden p-2 gap-2 d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_PosCart = _resolveComponent("PosCart")!
  const _component_PosCobro = _resolveComponent("PosCobro")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.ventaOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _cache[2] || (_cache[2] = _createTextVNode("✓ Venta registrada: ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.ventaOk), 1)
            ]),
            _createElementVNode("button", {
              class: "btn-close btn-close-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ventaOk = null))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PosCart, {
          carrito: _ctx.carrito,
          idalmacen: _ctx.idalmacen,
          style: {"flex":"1","min-width":"0"},
          onAgregar: _ctx.agregarAlCarrito,
          onQuitar: _ctx.quitarDelCarrito,
          onLimpiar: _ctx.limpiarCarrito
        }, null, 8, ["carrito", "idalmacen", "onAgregar", "onQuitar", "onLimpiar"]),
        _createVNode(_component_PosCobro, {
          carrito: _ctx.carrito,
          series: _ctx.series,
          idalmacen: _ctx.idalmacen,
          style: {"width":"460px","flex-shrink":"0","align-self":"stretch"},
          onLimpiar: _ctx.limpiarCarrito,
          onVentaRegistrada: _ctx.onVentaRegistrada,
          onAlmacenChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.idalmacen = $event))
        }, null, 8, ["carrito", "series", "idalmacen", "onLimpiar", "onVentaRegistrada"])
      ]),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}